export const sortByDate =
  (asc = 1, field = 'dateCreated') =>
  (a, b) => {
    const isFieldFunction = typeof field === 'function';

    const dateA = (isFieldFunction ? field(a) : a[field])?.toDate();
    const dateB = (isFieldFunction ? field(b) : b[field])?.toDate();

    if (dateA > dateB) return -1 * asc;
    if (dateA <= dateB) return 1 * asc;

    return 0;
  };

export const groupByDate = (items, field = 'dateUpdated') => {
  const isFieldFunction = typeof field === 'function';

  return items.reduce((acc, item) => {
    const itemDate = isFieldFunction ? field(item) : item[field];
    const jsDate = itemDate?.toDate();
    const dateKey = jsDate
      ? `${jsDate.getDate()}-${jsDate.getMonth() + 1}-${jsDate.getFullYear()}`
      : 'unknown';

    if (!acc[dateKey]) {
      acc[dateKey] = {
        date: itemDate,
        items: [item],
      };

      return acc;
    }

    acc[dateKey].items.push(item);

    return acc;
  }, {});
};
